module.exports = __webpack_public_path__ + "img/point.41bd7e20.png";